module.exports = __webpack_public_path__ + "media/assets/images/flags/bj-02b5eb86e109ff38332c1003bbf28f82.svg";